import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Layouts
import MainLayout from "./layouts/MainLayout";
import AdminLayout from "./layouts/AdminLayout";
import ChatWidget from "./components/pages/ChatWidget/ChatWidget";

// Pages Routes 
import Home from "./pages/Pages/Home/home";
import Login from "./pages/Pages/Auth/Login";
import Register from "./pages/Pages/Auth/Register";
import PropertyDetail from "./pages/Pages/PropertyDetail/PropertyDetail";
import PostRealEstateForm from "./pages/Pages/PostRealEstate/PostRealEstateForm";
import MyPosts from "./pages/Pages/Account/Mypost/MyPosts";
import Profile from "./pages/Pages/Account/MyAccount/Profile";
import PropertySearchPage from "./pages/Pages/PropertySearchPage";
import RecommendedCars from "./pages/Pages/RecommendedCars";
import Contact from "./pages/Pages/Contact/Contact";
import About from "./pages/Pages/About/About";
import VerifyEmail from "./pages/Pages/Auth/VerifyEmail";
import PrivateRoute from "./components/pages/PrivateRoute/PrivateRoute";
import EditProperty from "./pages/Pages/Account/Mypost/EditProperty";
import UserListing from "./pages/Pages/PropertyDetail/UserListing";
import ForgotPassword from "./layouts/auth/ForgotPassword";
import ResetPassword from "./layouts/auth/ResetPassword";
import ProjectsPage from "./pages/Pages/Projects/ProjectsPage";
import Overview from "./pages/Pages/Home/overview"
import NewsPage from "./pages/Pages/NewsPage/NewsPage"
// import BlogLayout1 from "./pages/Pages/NewsDetailPage/BlogLayout1";
// import BlogLayout2 from "./pages/Pages/NewsDetailPage/BlogLayout2";
// import BlogLayout3 from "./pages/Pages/NewsDetailPage/BlogLayout3";
// import BlogLayout4 from "./pages/Pages/NewsDetailPage/BlogLayout4";
// import BlogLayout5 from "./pages/Pages/NewsDetailPage/BlogLayout5";
// import BlogLayout6 from "./pages/Pages/NewsDetailPage/BlogLayout6";

// Admin routes
import AdminDashboard from "./pages/Admin/AdminDashboard";
import ManageUsers from "./pages/Admin/ManageUsers";
import ManageNotApproved from "./pages/Admin/ManageNotApproved";
import ManageProducts from "./pages/Admin/ManageProperties";
import ManageProject from "./pages/Admin/ManageProjects"
import ManageSettings from "./pages/Admin/ManageSettings";
import ManageContacts from "./pages/Admin/ManageContacts"
import NewsManagement from "./pages/Admin/NewsManagement";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/overview" element={<MainLayout><Overview /></MainLayout>} />

        {/* 🌐 Giao diện Người dùng (MainLayout) */}
        <Route path="/" element={<MainLayout><Home /></MainLayout>} />
        <Route path="/login" element={<MainLayout><Login /></MainLayout>} />
        <Route path="/register" element={<MainLayout><Register /></MainLayout>} />
        <Route path="/reset-password" element={<MainLayout><ResetPassword /></MainLayout>} />
        <Route path="/properties/:id" element={<MainLayout><PropertyDetail /></MainLayout>} />
        <Route path="/search" element={<MainLayout><PropertySearchPage /></MainLayout>} />
        <Route path="/recommended" element={<MainLayout><RecommendedCars /></MainLayout>} />
        <Route path="/contact" element={<MainLayout><Contact /></MainLayout>} />
        <Route path="/about" element={<MainLayout><About /></MainLayout>} />

        <Route path="/verify-email" element={<MainLayout><VerifyEmail /></MainLayout>} />
        <Route path="/user/:id" element={<MainLayout><UserListing /></MainLayout>} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/projects" element={<MainLayout><ProjectsPage /></MainLayout>} />
        <Route path="/news" element={<MainLayout><NewsPage /></MainLayout>} />
        {/* <Route path="/news/1" element={<MainLayout><BlogLayout1 /></MainLayout>} />
        <Route path="/news/2" element={<MainLayout><BlogLayout2 /></MainLayout>} />
        <Route path="/news/3" element={<MainLayout><BlogLayout3 /></MainLayout>} />
        <Route path="/news/4" element={<MainLayout><BlogLayout4 /></MainLayout>} />
        <Route path="/news/5" element={<MainLayout><BlogLayout5 /></MainLayout>} />
        <Route path="/news/6" element={<MainLayout><BlogLayout6 /></MainLayout>} />

        {/* 🔒 Các route yêu cầu đăng nhập */}
        <Route path="/post-car" element={
          <PrivateRoute>
            <MainLayout><PostRealEstateForm /></MainLayout>
          </PrivateRoute>
        } />
        <Route path="/my-properties" element={
          <PrivateRoute>
            <MainLayout><MyPosts /></MainLayout>
          </PrivateRoute>
        } />
        <Route path="/profile" element={
          <PrivateRoute>
            <MainLayout><Profile /></MainLayout>
          </PrivateRoute>
        } />
        <Route path="/edit-property/:id" element={
          <PrivateRoute>
            <MainLayout><EditProperty /></MainLayout>
          </PrivateRoute>
        } />

        {/* 🛠️ Giao diện Admin (AdminLayout) */}
        <Route
          path="/admin/"
          element={
            <AdminLayout />
          }
        >
          <Route index element={<AdminDashboard />} /> {/* /admin */}
          <Route path="dashboard" element={<AdminDashboard />} />
          <Route path="users" element={<ManageUsers />} />
          {/* <Route path="/admin/users/:id/cars" element={<UserCarsPage />} /> */}
          <Route path="notapproved" element={<ManageNotApproved />} />
          <Route path="properties" element={<ManageProducts />} />
          <Route path="projects" element={<ManageProject />} />
          <Route path="news" element={<NewsManagement />} />
          <Route path="settings" element={<ManageSettings />} />
          <Route path="contacts" element={<ManageContacts />} />
        </Route>
      </Routes>
      <ChatWidget />
    </Router>
  );
}

export default App;
